import { isTest } from './is-testing';
// eslint-disable-next-line no-restricted-imports -- this wrapper is the shared test-aware timer
import { timeout, waitForQueue } from 'ember-concurrency';

export async function waitForNext() {
  await timeout(1);
}

export async function waitForLater(delay = 0) {
  await timeout(delay);
}

// Return the yieldable so ember-concurrency tasks can `yield`/`await` it
// directly. Wrapping `timeout()` in `async`/`await` makes the helper a
// native Promise; async-arrow tasks then crash in production with
// `generator is not a function` because the executor never sees the
// yieldable protocol (and restartable debounce also loses cancellation).
export function testAwareTimeout(delay = 0) {
  return timeout(isTest() ? 0 : delay);
}

export async function waitForRender() {
  await waitForQueue('afterRender');
}

export async function testAwareWaitForLater(delay = 0) {
  if (!isTest()) {
    await timeout(delay);
  }
}
